import { QueryKeys } from '../../../queryKeys';
import { getRequest } from '../../../helpers/apiClient';
import apiRoutes from '../../../api-routes';
import { useQueryWithLogout } from '../../../hooks/useQueryWithLogout';

export const useNotificationUserInputs = (id, options) =>
  useQueryWithLogout(
    [QueryKeys.NOTIFICATION_USER_INPUTS, { id }],
    async () => {
      const { data } = await getRequest({
        url: apiRoutes.NOTIFICATION_USER_INPUTS.replace('{id}', id),
      });
      return data;
    },
    options,
  );
